import { initTeaserSliders } from '../shared/teaser-slider';

document.addEventListener('DOMContentLoaded', initTeaserSliders);
